import React, { useState, useEffect } from 'react';
import CyberMemorialService from '../../services/FamilyPlaza/CyberMemorialService';
import DeceasedUserImg from '../../assets/img/family-plaza/DeceasedUser.png';



const DeceasedPersonProfile = ({  
  handlePhotoIconClick 
}) => {
  const [photoThumbUrl, setPhotoThumbUrl] = useState('');
  const [photoUrl, setPhotoUrl] = useState('');
  const selectedPersonData = localStorage.getItem('selectedPersonData');
  const personData = selectedPersonData ? JSON.parse(selectedPersonData) : {};

  const loadProfilePhoto = async () => {
    try {
      if (selectedPersonData) {
        const personData = JSON.parse(selectedPersonData);
        const goinId = personData.goinId;

        if (goinId) {
          // API: GET /api/v1/cherish/{goinId}
          // Response: { cherishList: [...], lettersWithAuthor: [...] }
          const response = await CyberMemorialService.getGoinProfileImage(goinId);
          
          // Validate response structure per Swagger
          if (response && response.cherishList && Array.isArray(response.cherishList) && response.cherishList.length > 0) {
            const profileData = response.cherishList[0];
            
            // Store cherishId and goinId in localStorage
            if (profileData.cherishId) {
              localStorage.setItem('cherishId', profileData.cherishId);
            }
            if (profileData.goinId) {
              localStorage.setItem('goinId', profileData.goinId);
            }
            
            // Extract photo URLs from cherishList[0] per Swagger response
            // cherishList[0] contains: photoThumbUrl, photoUrl
            setPhotoThumbUrl(profileData.photoThumbUrl || '');
            setPhotoUrl(profileData.photoUrl || '');
          }
        }
      }
    } catch (error) {
      console.error('Error loading profile photo:', error);
    }
  };

  useEffect(() => {
    loadProfilePhoto();
      }, []);

  return (
    <div className="deceased-person-profile">
      {/* Desktop Layout */}
      <div className="deceased-person-profile-desktop">
        <div className="deceased-person-profile-image">
          <img src={photoThumbUrl || photoUrl || DeceasedUserImg} alt="Profile" />
        </div>
        <div className="deceased-person-profile-content">
          <p className="deceased-person-profile-text">보고 싶고 그리운 사람</p>
          <p className="deceased-person-profile-subtext">{`${personData.goinName}님의 사이버 추모관 입니다.`}</p>
        </div>
        <div className="deceased-person-profile-info">
          <span className="deceased-person-profile-date">{`${personData.deathDate} 별세`}</span>
          <div 
            className="deceased-person-profile-camera-icon" 
            onClick={handlePhotoIconClick}
            style={{ cursor: 'pointer' }}
          >
            <img src="/donate/photo-camera-copy.png" alt="Camera" />
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="deceased-person-profile-mobile">
        {/* Group Image 1 */}
        <div className="deceased-person-profile-group-image">
          <img src={photoThumbUrl || photoUrl || DeceasedUserImg} alt="Group" />
        </div>

        {/* Profile Section */}
        <div className="deceased-person-profile-section-mobile">
          <div className="deceased-person-profile-text-mobile">
            <p>{`${personData.goinName}님의 사이버 추모관 입니다.`}</p>
            <p>{`${personData.deathDate} 별세`}</p>
          </div>
        </div>

        {/* Group Image 2 */}
        <div className="deceased-person-profile-group-image"
         onClick={handlePhotoIconClick}
         style={{ cursor: 'pointer' }}>
          <img 
            src="/mobile donate/group-93.png" 
            alt="Group" 
          />
        </div>
      </div>
    </div>
  );
};

export default DeceasedPersonProfile;
